import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "intro" }
const _hoisted_2 = { id: "name" }
const _hoisted_3 = {
  id: "vocation",
  class: "section"
}
const _hoisted_4 = {
  id: "location",
  class: "section"
}
const _hoisted_5 = { id: "links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "name", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "vocation", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "location", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "links", {}, undefined, true)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))
    ])
  ]))
}